module.exports = __webpack_public_path__ + "483351b66d7f49ef56b83ecb00dd3712.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensanssemibold.ttf
// module id = 691
// module chunks = 57